import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteUserModal",
  tabindex: "-1",
  "aria-labelledby": "deleteUserModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 fw-bold text-center",
  id: "deleteUserModalLabel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-footer justify-content-center" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { translate } from '@/languages/i18n'
import communityManagerServices from '@/services/community-managers.services'
import Button from '@/components/button/index.vue'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  userDelete: Object as PropType<{ name: any; management_no: string }>,
  showMessageDelete: Function as PropType<any>,
  totalRecord: Number,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()



// 2022/09/15 TienNV Fix double click button confirm delete
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteUserModal'))
  modalSuccess.value = new Modal(document.getElementById('deleteUserSuccessModal'))
})
const loading = ref(false)

const onDelete = async (): Promise<void> => {
  loading.value = true
  try {
    const response = await communityManagerServices.deleteAdministratorApi({ id: route.params?.id, management_no: props.userDelete?.management_no })

    if (response.status === 200) {
      props.showMessageDelete(false)
      const payload = {
        management_no: props.userDelete?.management_no,
        totalRecord: props?.totalRecord,
      }
      store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.UPDATE_LIST_USERS, payload)
      //2022/09/15 TienNV Fix double click button confirm delete
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        loading.value = false
      }, 2000)
      return
    }
    props.showMessageDelete(true)
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
  } catch (error) {
    console.log(error)
    props.showMessageDelete(true)
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, "「" + _toDisplayString(__props.userDelete?.family_name + ' ' + __props.userDelete?.given_name) + "」" + _toDisplayString(_unref(translate)('deleteText')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(translate)('SO65delete'),
            type: 'secondary',
            onClick: onDelete,
            loading: loading.value,
            disabled: loading.value
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})